import React, { useState } from 'react';
import { Volume2, Sparkles, Grid, Zap, MessageSquare } from 'lucide-react';

export const CoreVocabAIModule: React.FC = () => {
  const [selectedWords, setSelectedWords] = useState<string[]>(['I', 'WANT']);

  const coreGrid = [
    { word: 'I', color: 'bg-yellow-500 text-slate-950' },
    { word: 'WANT', color: 'bg-green-600 text-white' },
    { word: 'GO', color: 'bg-blue-600 text-white' },
    { word: 'HELP', color: 'bg-red-600 text-white' },
    { word: 'STOP', color: 'bg-orange-600 text-white' },
    { word: 'MORE', color: 'bg-purple-600 text-white' },
    { word: 'WATER', color: 'bg-cyan-600 text-white' },
    { word: 'EAT', color: 'bg-emerald-600 text-white' },
    { word: 'PLAY', color: 'bg-indigo-600 text-white' },
    { word: 'PLEASE', color: 'bg-pink-600 text-white' },
    { word: 'HAPPY', color: 'bg-teal-600 text-white' },
    { word: 'ALL DONE', color: 'bg-slate-700 text-white' }
  ];

  const aiPredictions = ['WATER', 'PLAY', 'REST', 'OUTSIDE'];

  const handleAddWord = (w: string) => {
    setSelectedWords([...selectedWords, w]);
  };

  const handleSpeak = () => {
    const text = selectedWords.join(' ');
    if ('speechSynthesis' in window) {
      const utterance = new SpeechSynthesisUtterance(text);
      window.speechSynthesis.speak(utterance);
    }
  };

  return (
    <div className="p-6 space-y-6 bg-slate-900 text-white rounded-2xl">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-slate-800 pb-4">
        <div>
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-cyan-500/20 text-cyan-300 text-xs font-bold rounded-full border border-cyan-500/30">
            <Grid className="w-3.5 h-3.5" /> Module 26: Motor-Planning Dynamic Core Vocab & AI Predictor
          </div>
          <h2 className="text-2xl font-black mt-2">Crescendo Motor Vocabulary & Transformer Prediction</h2>
        </div>
      </div>

      <div className="bg-slate-950 p-4 rounded-2xl border border-slate-800 space-y-3">
        <div className="flex items-center justify-between">
          <div className="text-xs font-bold text-slate-400">Assembled Sentence Bar:</div>
          <button onClick={() => setSelectedWords([])} className="text-xs text-red-400 hover:underline">Clear</button>
        </div>
        <div className="flex items-center gap-2 p-3 bg-slate-900 rounded-xl min-h-[50px] border border-slate-800 flex-wrap">
          {selectedWords.map((w, idx) => (
            <span key={idx} className="px-3 py-1.5 bg-blue-600 text-white font-extrabold text-xs rounded-lg shadow-sm">
              {w}
            </span>
          ))}
        </div>
        <button onClick={handleSpeak} className="w-full py-3 bg-emerald-500 hover:bg-emerald-600 text-white font-bold rounded-xl text-xs flex items-center justify-center gap-2 shadow">
          <Volume2 className="w-4 h-4" /> Speak Sentence with Natural TTS Voice
        </button>
      </div>

      <div className="space-y-2">
        <div className="text-xs font-bold text-amber-400 flex items-center gap-1.5">
          <Sparkles className="w-4 h-4" /> AI Next-Word Transformer Suggestions:
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          {aiPredictions.map((pred, idx) => (
            <button key={idx} onClick={() => handleAddWord(pred)} className="px-3 py-1.5 bg-amber-500/20 text-amber-300 border border-amber-500/40 rounded-xl text-xs font-bold hover:bg-amber-500/30 transition">
              + {pred}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-3 sm:grid-cols-4 gap-2 pt-2">
        {coreGrid.map((item, idx) => (
          <button key={idx} onClick={() => handleAddWord(item.word)} className={`p-4 rounded-2xl font-black text-xs shadow hover:scale-[1.03] transition ${item.color}`}>
            {item.word}
          </button>
        ))}
      </div>
    </div>
  );
};
